import styled from 'styled-components';

export const Container = styled.div`
  table {
    border-collapse: separate;
    border-spacing: 0px 4px;
    white-space: nowrap;
    /* border-collapse: collapse; */

    thead {
      tr {
        height: 45px;
        background-color: #f4f4f4;
        border-radius: 5px;

        th {
          border-top: 0.79705px solid #dedede;
          border-bottom: 0.79705px solid #dedede !important;

          color: #482727;
          border-bottom: 0px;
          padding: 3px 16px;
          background-color: transparent;

          :first-child {
            border-left: 0.79705px solid #dedede;

            border-top-left-radius: 3.76284px;
            border-bottom-left-radius: 3.76284px;
          }

          :last-child {
            border-right: 0.79705px solid #dedede;

            border-top-right-radius: 3.76284px;
            border-bottom-right-radius: 3.76284px;
          }
        }
      }
    }

    tbody:before {
      content: '@';
      display: block;
      line-height: 2px;
      text-indent: -99999px;
    }

    tr {
      height: 45px;

      #name {
        position: relative;
        width: 100%;

        > div {
          position: absolute;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          max-width: 100%;
          top: 0;
          bottom: 0;
          margin: auto 0;
          height: 1.5em;
          padding-right: 16px;
        }
      }

      #date {
        padding: 0px 32px;
      }

      td {
        background-color: #fff;
        border-bottom: 0px;
        color: #311d1d;
        padding: 3px 16px;
        border-top: 0.79705px solid #dedede;
        border-bottom: 0.79705px solid #dedede;
        box-sizing: border-box;

        :first-child {
          border-left: 0.79705px solid #dedede;

          border-top-left-radius: 3.76284px;
          border-bottom-left-radius: 3.76284px;
        }

        :last-child {
          border-right: 0.79705px solid #dedede;

          border-top-right-radius: 3.76284px;
          border-bottom-right-radius: 3.76284px;
        }

        button {
          padding: 4px;
        }
      }
    }
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #989898; // color of icons

    svg {
      font-size: 22px; // cellphone icon
    }
  }
`;
